import { useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { withFirstLetterCapitalized } from "@/lib/autoCapitalize";
import DeskConfirm, { R2_INPUT } from "@/components/crm/DeskConfirm";

/**
 * AviDecisionModal — Approuver / Reçu / Marquer comme lu / Refuser — R2 (iter393).
 * Approuver : commentaire optionnel typé (réserve / recommandation / remarque). Refuser : motif obligatoire (≥ 3 car.).
 */
const COMMENT_TYPES = [
  { key: "reserve", label: "Réserve", color: "#F97316" },
  { key: "recommandation", label: "Recommandation", color: "#3B82F6" },
  { key: "remarque", label: "Remarque", color: "#84CC16" },
];

export default function AviDecisionModal({ decision, onClose, onConfirm }) {
  const isApprove = decision === "approuvee";
  const isAccuse = decision === "accusee";
  const isRead = decision === "lue";
  const isPositive = isApprove || isAccuse || isRead;
  const [reason, setReason] = useState("");
  const [commentType, setCommentType] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (motif) => {
    if (saving) return;
    setSaving(true);
    try { await onConfirm({ reason: (isPositive ? reason.trim() : motif) || null, comment_type: isApprove ? commentType : null }); } finally { setSaving(false); }
  };

  const title = isApprove ? "Approuver la demande ?" : isAccuse ? "Confirmer la réception ?" : isRead ? "Marquer comme lu ?" : "Refuser la demande ?";
  const positiveLabel = isApprove ? "Approuver" : isAccuse ? "Reçu" : "Marquer comme lu";
  return (
    <DeskConfirm open danger={!isPositive} icon={isPositive ? CheckCircle2 : XCircle} title={title} busy={saving}
      message={isPositive ? undefined : "Le motif du refus est notifié au demandeur."}
      withReason={!isPositive} reasonPlaceholder="Motif du refus (obligatoire, 3 caractères min.)"
      confirmLabel={saving ? "Envoi…" : isPositive ? positiveLabel : "Refuser"} onClose={() => { if (!saving) onClose?.(); }} onConfirm={submit} testId="avi-decision-modal">
      {isPositive && (
        <div className="grid" style={{ gap: 8 }}>
          {isApprove && (
            <div className="grid grid-cols-3" style={{ gap: 6 }}>
              {COMMENT_TYPES.map((c) => { const on = commentType === c.key; return (
                <button key={c.key} type="button" onClick={() => setCommentType(on ? null : c.key)} style={{ height: 28, borderRadius: 8, fontSize: 10.5, fontWeight: 600, background: on ? `${c.color}22` : "transparent", border: `1px solid ${on ? c.color : "#2a2a30"}`, color: on ? c.color : "#8A8A96" }} data-testid={`avi-comment-type-${c.key}`}>{c.label}</button>
              ); })}
            </div>
          )}
          <textarea value={reason} onChange={withFirstLetterCapitalized((e) => setReason(e.target.value))} rows={2} autoFocus
            placeholder={isApprove ? "Commentaire (facultatif)…" : isAccuse ? "Message (facultatif) — « bien reçu », « noté »…" : "Commentaire (facultatif)…"}
            className="resize-none placeholder:text-[#5a5a63]" style={R2_INPUT} data-testid="avi-decision-reason" />
        </div>
      )}
    </DeskConfirm>
  );
}
